import { render } from "./PDFIcon.vue?vue&type=template&id=c1939f88"
import script from "./PDFIcon.vue?vue&type=script&lang=js"
export * from "./PDFIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/shared/Icons/PDFIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c1939f88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c1939f88', __exports__)) {
    api.reload('c1939f88', __exports__)
  }
  
  module.hot.accept("./PDFIcon.vue?vue&type=template&id=c1939f88", () => {
    api.rerender('c1939f88', render)
  })

}


export default __exports__